import axios from "axios"

import * as actions from "../actions/lookupCode"
import { REGION, QUALIFICATION, GENDER, SKILL } from '../js/const'

export function getQualifications(isCheckingActive, selectedLovIds) {
  return (dispatch) => {
    return getLookupCodes(dispatch, QUALIFICATION, actions.getQualifications, isCheckingActive, selectedLovIds)
  }
}

export function getRegions(isCheckingActive, selectedLovIds) {
  return (dispatch) => {
    return getLookupCodes(dispatch, REGION, actions.getRegions, isCheckingActive, selectedLovIds)
  }
}

export function getGenders(isCheckingActive, selectedLovIds) {
  return (dispatch) => {
    return getLookupCodes(dispatch, GENDER, actions.getGenders, isCheckingActive, selectedLovIds)
  }
}

export function getSkills(isCheckingActive, selectedLovIds) {
  return (dispatch) => {
    return getLookupCodes(dispatch, SKILL, actions.getSkills, isCheckingActive, selectedLovIds)
  }
}

function getLookupCodes(dispatch, codeType, updateFunction, isCheckingActive, selectedLovIds) {
  let url = `${process.env.REACT_APP_API_HOST}/api/lookup-code/${codeType}/${isCheckingActive}`
  if (selectedLovIds && selectedLovIds.length > 0) {
    url = `${url}?`
    selectedLovIds.forEach(selectedLovId => {
      url = `${url}selectedLovIds=${selectedLovId}&`
    })
    url = url.substring(0, url.length - 1)
  }
  return axios.get(url)
    .then((response) => {
      let codes = response && response.data ? response.data.$values : []
      dispatch(updateFunction(codes))
    })
}

export function updateLookupCode(lookupCode) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(`${process.env.REACT_APP_API_HOST}/api/lookup-code`, lookupCode)
        .then(response => {
          if (response && response.data.Success) {
            dispatch(actions.getGenders())
            dispatch(actions.getSkills())
            dispatch(actions.getQualifications())
            dispatch(actions.getRegions())
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function deleteLookupCode(lookupCodeId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.delete(`${process.env.REACT_APP_API_HOST}/api/lookup-code/${lookupCodeId}`)
        .then(response => {
          if (response && response.data.Success) {
            dispatch(actions.getGenders())
            dispatch(actions.getSkills())
            dispatch(actions.getQualifications())
            dispatch(actions.getRegions())
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}


// WEBPACK FOOTER //
// ./src/actionCreators/lookupCode.js